export const StrategyDetailTabs = [
  {
    id: 1,
    title: 'General',
    value: 'general',
  },
  {
    id: 2,
    title: 'Performance',
    value: 'perfomance',
  },
  {
    id: 3,
    title: 'Investors',
    value: 'investors',
  },
  {
    id: 4,
    title: 'Commissions',
    value: 'commissions',
  },
]
